var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"2e91a5a9814f5384b4e234c3c71c5310bda86b4d"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["yapdomik-frontend-website@sushi-market"]={id:"2e91a5a9814f5384b4e234c3c71c5310bda86b4d"};
      